<template>
    <section>
        <app-header></app-header>
        <div>
            <section class="home-banner inner-banner">
                <div class="container-lg position-relative">
                    <h2 class="font-bold page-title text-center">Contact</h2> <img
                        src="/assets/custom/img/bottle-n-leaf.png" width="440" height="339" class="bnr-organic-left">
                    <img src="/assets/custom/img/sunflower-organic.png" width="440" height="339"
                        class="bnr-organic-right">
                </div>
                <div class="wall"></div> <img src="/assets/custom/img/assets.png" width="440" height="339"
                    class="assets">
            </section>
            <section class="category-description">
                <div class="container-lg">
                    <div class="py-5">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="pl-5 position-relative"><i
                                        class="las la-map-marker-alt position-absolute left-0 h2 text-green"></i>
                                    <h4 class="font-bold">REACH US</h4>
                                    MRT ORGANIC GREEN PRODUCTS<br>
                                    MRT House, AMC 17/323/325<br>
                                    SWTS Road, Azizi Junction,<br>
                                    Aluva - 683101, Cochin, Kerala, India.
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="pl-5 pb-4 position-relative"><i
                                        class="las la-tty position-absolute left-0 h2 text-green"></i>
                                    +91-484-2632991,<br>
                                    +91-484-2124310
                                </div>
                                <div class="pl-5 pb-4 position-relative"><i
                                        class="las la-mobile-alt position-absolute left-0 h2 text-green"></i>
                                    +91-9746039299
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="pl-5 pb-4 position-relative"><i
                                        class="las la-fax position-absolute left-0 h2 text-green"></i>
                                    +91-484-2624133
                                </div>
                                <div class="pl-5 position-relative"><i
                                        class="las la-envelope position-absolute left-0 h2 text-green"></i>
                                    organic@mrtorganic.com
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent="contactAdmin">
                            <div class="bg-white p-md-5 p-4 shadow rounded mt-5 contact-form">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label for="formGroupExampleInput">Name</label>
                                            <input
                                                name="name" 
                                                v-model="name" 
                                                type="text" 
                                                id="formGroupExampleInput"
                                                placeholder="Enter Name" 
                                                :disabled="loading"
                                                class="form-control form-control-lg"
                                                :class="$v.name.$error ? 'is-invalid' : ''"
                                            />
                                            <div class="invalid-feedback" v-if="$v.name.$error">Name is required</div>
                                        </div>
                                        <div class="form-group">
                                            <label for="formGroupExampleInput2">Email</label>
                                            <input
                                                name="email" 
                                                v-model="email" 
                                                type="email" 
                                                id="formGroupExampleInput2"
                                                placeholder="Enter email" 
                                                :disabled="loading"
                                                class="form-control" 
                                                :class="$v.email.$error ? 'is-invalid' : ''"
                                            />
                                            <div class="invalid-feedback" v-if="$v.email.$error">Email is required</div>
                                        </div>
                                        <div class="form-group">
                                            <label for="formGroupExampleInput2">Mobile</label>
                                            <input 
                                                name="phone" 
                                                v-model="phone" 
                                                type="text" 
                                                id="formGroupExampleInput2"
                                                placeholder="Enter mobile " 
                                                :disabled="loading"
                                                class="form-control"
                                                :class="$v.phone.$error ? 'is-invalid' : ''"
                                            />
                                            <div class="invalid-feedback" v-if="$v.phone.$error">Phone is required</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label for="exampleFormControlTextarea1">Message</label>
                                            <textarea 
                                                name="message" 
                                                id="exampleFormControlTextarea1" 
                                                rows="7"
                                                class="form-control" 
                                                :disabled="loading"
                                                placeholder="Enter your message"
                                                v-model="message" 
                                                spellcheck="false"
                                                :class="$v.message.$error ? 'is-invalid' : ''"
                                            ></textarea>
                                            <div class="invalid-feedback" v-if="$v.message.$error">Message is required</div>
                                        </div>
                                        <div class="text-right">
                                            <input 
                                                type="submit" 
                                                id="submit"
                                                :disabled="loading"
                                                class="btn btn-dark text-white font-bold px-5" 
                                                :value="loading ? 'Sending...' : 'Submit'"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <app-certification />
        </div>
        <app-footer></app-footer>
    </section>
</template>

<script>
import Header from './header.vue';
import Footer from './footer.vue';
import Certification from './index/Certification.vue';
import { required } from 'vuelidate/lib/validators';
export default {
    name: "Contact",
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            message: "",
            loading: false
        }
    },
    validations: {
        name: {
            required
        },
        email: {
            required
        },
        phone: {
            required
        },
        message: {
            required
        },
    },
    methods: {
        contactAdmin() {
            this.$v.$touch();

            if(!this.$v.$invalid) {
                this.loading = true;

                const formData = new FormData();
                
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append("message", this.message);

                axios.post(`/api/enqueries`, formData)
                .then(res => {
                    this.name = "";
                    this.email = "";
                    this.phone = "";
                    this.message = "";
                    this.$v.$reset();
                }).catch(error => {
                    console.error(error.response);
                }).finally(res => {
                    this.loading = false;
                });
            }
        }
    },
    components: {
        "app-header": Header,
        "app-footer": Footer,
        "app-certification": Certification
    }
}
</script>
